import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePauseIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16 2a3 3 0 0 0-3 3v14a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Zm1 17a1.0001 1.0001 0 0 1-2 0V5a1.0002 1.0002 0 0 1 1.7071-.7071C16.8946 4.4804 17 4.7348 17 5v14ZM8 2a3 3 0 0 0-3 3v14a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Zm1 17a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v14Z"/>
  </SvgIcon>
}

export default LinePauseIcon
